import { render, staticRenderFns } from "./KimModalIcon.vue?vue&type=template&id=4c16b36d"
import script from "./KimModalIcon.vue?vue&type=script&lang=js"
export * from "./KimModalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports